import { Routes } from '@angular/router';

import { authGuard } from '@abp/ng.core';

export const routes: Routes = [
  {
    path: 'account',
    loadChildren: () => import('@volo/abp.ng.account/public').then((m) => m.createRoutes()),
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: 'identity',
        loadChildren: () => import('@volo/abp.ng.identity').then((m) => m.createRoutes()),
      },
      {
        path: 'language-management',
        loadChildren: () => import('@volo/abp.ng.language-management').then((m) => m.createRoutes()),
      },
      {
        path: 'saas',
        loadChildren: () => import('@volo/abp.ng.saas').then((m) => m.createRoutes()),
      },
      {
        path: 'audit-logs',
        loadChildren: () => import('@volo/abp.ng.audit-logging').then((m) => m.createRoutes()),
      },
      {
        path: 'openiddict',
        loadChildren: () => import('@volo/abp.ng.openiddictpro').then((m) => m.createRoutes()),
      },
      {
        path: 'text-template-management',
        loadChildren: () => import('@volo/abp.ng.text-template-management').then((m) => m.createRoutes()),
      },
      {
        path: 'setting-management',
        loadChildren: () => import('@abp/ng.setting-management').then((m) => m.createRoutes()),
      },
      {
        path: 'chat',
        loadChildren: () => import('@volo/abp.ng.chat').then((m) => m.createRoutes()),
      },
      {
        path: 'nav-file-management',
        loadChildren: () => import('@nexweb/shared/abp/file-management').then((m) => m.createRoutes()),
      },
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () => import('@nexweb/mtp/feature-home').then((m) => m.routes),
      },
      {
        path: 'amt',
        loadChildren: () => import('@nexweb/amt/feature/shell').then((m) => m.routes),
      },
      {
        path: 'setrep',
        loadChildren: () => import('@nexweb/setrep/feature/shell').then((m) => m.routes),
      },
      {
        path: 'tsam',
        loadChildren: () => import('@nexweb/tsam/feature/shell').then((m) => m.routes),
      },
      {
        path: 'emmd',
        loadChildren: () => import('@nexweb/emmd/feature/shell').then((m) => m.routes),
      },
      {
        path: 'cmt',
        loadChildren: () => import('@nexweb/cmt/feature/shell').then((m) => m.routes),
      },
      {
        path: 'bm',
        loadChildren: () => import('@nexweb/bm/feature/shell').then((m) => m.routes),
      },
      {
        path: 'aum',
        loadChildren: () => import('@nexweb/aum/feature/shell').then((m) => m.routes),
      },
      {
        path: 'samm',
        loadChildren: () => import('@nexweb/samm/feature/shell').then((m) => m.routes),
      },
      {
        path: 'menu',
        loadChildren: () => import('@nexweb/menu/feature/shell').then((m) => m.routes),
      },
      {
        path: 'cal',
        loadChildren: () => import('@nexweb/cal/feature/shell').then((m) => m.routes),
      },
      {
        path: 'tou',
        loadChildren: () => import('@nexweb/tou/feature/shell').then((m) => m.routes),
      },
      {
        path: 'smas',
        loadChildren: () => import('@nexweb/smas/feature/shell').then((m) => m.routes),
      },
      {
        path: 'mdd',
        loadChildren: () => import('@nexweb/mdd/feature/shell').then((m) => m.routes),
      },
      {
        path: 'scheduler',
        loadChildren: () => import('@nexweb/scheduler/feature/shell').then((m) => m.routes),
      },
      {
        path: 'bulkdownload',
        loadChildren: () => import('@nexweb/bulk-download/feature/shell').then((m) => m.routes),
      },
      {
        path: 'sappmtp',
        loadChildren: () => import('@nexweb/sappmtp/feature/shell').then((m) => m.routes),
      },
    ],
  },
];
